<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <h2>Skrivare</h2>
      </div>
      <div class="card-body">
        <div class="toggle-buttons">
          <button
            class="btn btn-toggle"
            :class="{ active: searchType === 'macAddress' }"
            @click="setSearchType('macAddress')">
            MAC-adress
          </button>
          <button
            class="btn btn-toggle"
            :class="{ active: searchType === 'serialNumber' }"
            @click="setSearchType('serialNumber')">
            Serienummer
          </button>
        </div>

        <form
          @submit.prevent="handleSubmit('printer')"
          class="search-form">
          <div
            v-if="searchType === 'macAddress'"
            class="form-group">
            <label for="macAddress">Mac address:</label>
            <input
              type="text"
              id="macAddress"
              placeholder="Ange MAC-adress"
              v-model="search.macAddress"
              class="form-control"
              required />
          </div>
          <div
            v-if="searchType === 'serialNumber'"
            class="form-group">
            <label for="serialNumber">Serienummer:</label>
            <input
              type="text"
              id="serialNumber"
              placeholder="Ange serienummer"
              v-model="search.serialNumber"
              class="form-control"
              required />
          </div>

          <div v-if="printer">
            <ul>
              <li
                v-for="(value, key) in printer"
                :key="key">
                <strong>{{ key }}:</strong> {{ value }}
              </li>
            </ul>
          </div>
          <p v-else>
            <strong>Inget resultat</strong>
          </p>
          <button
            type="submit"
            class="btn btn-primary"
            :disabled="loading">
            Sök
          </button>
        </form>
      </div>
    </div>

    <!-- Club Search Card -->
    <div class="card">
      <div class="card-header">
        <h2>Klubb</h2>
      </div>
      <div class="card-body">
        <form
          @submit.prevent="handleSubmit('club')"
          class="search-form">
          <div class="form-group">
            <label for="integrationId">Integration ID:</label>
            <input
              type="text"
              id="integrationId"
              placeholder="Ange integration ID"
              v-model="search.integrationId"
              class="form-control"
              required />
          </div>
          <div v-if="club">
            <ul>
              <li
                v-for="(value, key) in club"
                :key="key">
                <strong>{{ key }}:</strong> {{ value }}
              </li>
            </ul>
          </div>
          <p v-else>
            <strong>Inget resultat</strong>
          </p>
          <button
            type="submit"
            class="btn btn-primary"
            :disabled="loading">
            Sök
          </button>
        </form>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h2>Klubbinfo Print API (ej klar)</h2>
      </div>
      <div class="card-body">
        <form
          @submit.prevent="handleSubmit('printClub')"
          class="search-form">
          <div class="form-group">
            <label for="integrationId">Klubb GUID:</label>
            <input
              type="text"
              id="integrationId"
              placeholder="Ange Klubb GUID"
              v-model="search.printClubId"
              class="form-control"
              required />
          </div>
          <div v-if="printClub">
            <ul>
              <li
                v-for="(value, key) in printClubclub"
                :key="key">
                <strong>{{ key }}:</strong> {{ value }}
              </li>
            </ul>
          </div>
          <p v-else>
            <strong>Inget resultat</strong>
          </p>
          <button
            type="submit"
            class="btn btn-primary"
            :disabled="loading">
            Sök
          </button>
        </form>
      </div>
    </div>

    <!-- Client Search Card -->
    <div class="card">
      <div class="card-header">
        <h2>Klient</h2>
      </div>
      <div class="card-body">
        <form
          @submit.prevent="handleSubmit('client')"
          class="search-form">
          <div class="form-group">
            <label for="clientId">Klient ID: (OnTagWxxx)</label>
            <input
              type="text"
              id="clientId"
              placeholder="Ange klient ID"
              v-model="search.clientId"
              class="form-control"
              required />
          </div>
          <div v-if="client">
            <ul>
              <li
                v-for="(value, key) in client"
                :key="key">
                <strong>{{ key }}:</strong> {{ value }}
              </li>
            </ul>
          </div>
          <p v-else>
            <strong>Inget resultat</strong>
          </p>
          <button
            type="submit"
            class="btn btn-primary"
            :disabled="loading">
            Sök
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchType: 'macAddress', // Default search type for printer search
      search: {
        macAddress: '',
        serialNumber: '',
        integrationId: '',
        clientId: '',
      },
      loading: false,
    };
  },
  computed: {
    printer() {
      return this.$store.getters['printers/printer'];
    },
    club() {
      return this.$store.getters['clubs/club'];
    },
    client() {
      return this.$store.getters['clients/client'];
    },
  },
  methods: {
    setSearchType(type) {
      this.searchType = type;
      if (type === 'macAddress') {
        this.search.serialNumber = '';
      } else if (type === 'serialNumber') {
        this.search.macAddress = '';
      }
    },
    async handleSubmit(type) {
      let payload = {};
      this.loading = true;

      if (type === 'printer') {
        // Include only the relevant search parameter based on searchType
        if (this.searchType === 'macAddress') {
          payload = { macAddress: this.search.macAddress };
        } else if (this.searchType === 'serialNumber') {
          payload = { serialNumber: this.search.serialNumber };
        }
        await this.$store.dispatch('printers/findPrinter', payload);
      } else if (type === 'club') {
        payload = { integrationId: this.search.integrationId };
        await this.$store.dispatch('clubs/findClub', payload);
      } else if (type === 'client') {
        payload = { clientId: this.search.clientId };
        await this.$store.dispatch('clients/findClient', payload);
      } else if (type === 'printClub') {
        payload = { printClubId: this.search.printClubId };

        await this.$store.dispatch('clubs/getClubInfo', payload);
      }

      this.loading = false;
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  padding: 20px;
  display: flex;
  gap: 3rem;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 5rem;
}

.card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  height: fit-content;
  width: 100%;
  max-width: 80%;
}

.card-header {
  background-color: #007bff;
  color: #fff;
  padding: 15px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.card-body {
  padding: 20px;
}

h2 {
  margin: 0;
  font-size: 22px;
  font-weight: bold;
}

.toggle-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.btn {
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
}

.btn-toggle {
  background-color: #f0f0f0;
  color: #333;
  transition: background-color 0.3s;
}

.btn-toggle.active {
  background-color: #007bff;
  color: #fff;
}

.form-group {
  margin-bottom: 15px;
}

.label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.form-control {
  width: 100%;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  transition: border-color 0.2s;
}

.form-control:focus {
  outline: none;
  border-color: #007bff;
}

.btn-primary {
  background-color: #007bff;
  color: #fff;
}

.btn-primary:disabled {
  background-color: #6c757d;
}

.response {
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 4px;
  font-family: 'Courier New', Courier, monospace;
  white-space: pre-wrap;
}
</style>
